//
// Maps page keys to the privilege codes required to access them.
// Used by PrivilegeGate and SideMenu to show/hide or dim menu items.
//

// Page-to-privilege mapping
// Pages not listed here are always accessible (e.g. profile)
const pagePrivilegesNeeded = {
  home: [],
  cases: [], // 'reportsSynopsis', 'reportsDetails', 'reportsHandle', 'reportsTalkToUsers'],
  tasks: [],
  qrs: ['qrView', 'qrManage', 'qrEdit'],
  stats: ['reportsStats'],
  polls: ['pollViewResults', 'pollManage', 'pollEdit'],
  comms: ['infoView', 'infoManage', 'infoEdit'],
  responders: ['manager', 'admin'],
  users: ['admin'],
  customization: ['brandEdit'],
};

export default pagePrivilegesNeeded;
